export const calculateMaxTickWidth = (data, keys, tickFormatter) => {
  let maxWidth = 0;
  data.forEach((item) => {
    keys.map((key) => {
      const tickValue = tickFormatter ? tickFormatter(item[key]) : item[key];
      if (tickValue.length > maxWidth) {
        maxWidth = tickValue.length;
      }
    });
  });

  return Math.ceil(maxWidth) * 5 + 20;
};
